/**
 * Common Sentry configuration for HL pages and ng-checkout.
 */
export const commonSentryConfig = {
  environment: process.env.SENTRY_ENVIRONMENT,
  dsn: 'https://9a6f2e2dd0324a6e898b1a275d0afb88@o510915.ingest.us.sentry.io/5607267',
  release: process.env.SENTRY_RELEASE,
  sampleRate: parseFloat(process.env.SENTRY_SAMPLE_RATE),
  denyUrls: [
    /^(chrome|moz|safari(-web)?)-extension:\/\//i, // Chrome, Firefox and Safari extensions
    /^webkit-masked-url:/i, // Safari masks extension URLs with this scheme
    /^iabjs:\/\//i, // Facebook Android in-app browser
    /^file:\/\//i, // Copy of the page saved to disk
    /^https:\/\/static\.cloudflareinsights\.com\//i, // Cloudflare Web Analytics beacon
  ],
  beforeSend(event) {
    event.tags = {
      ...event.tags,
      order_id: window?.localStorage?.getItem('transaction_id') || null,
    };

    return event;
  },
};
